<script>
    import FancyButton from './FancyButton.svelte';
</script>


<FancyButton label="Choose One at Random" image={"/random.svg"}/>